import React from 'react'
// import gif from './dwight-schrute-the-office.gif'

export default function Container({ items, isLoading }) {
  return isLoading ? (
    <h1>is loading..</h1>
  ) : (
    <div className='container'>
      {/* <img src={gif} alt='' /> */}
      {items.map((item) => (
        <div className='card'>
          <blockquote>{item.content}</blockquote>
          <cite>
            {item.character.firstname} {item.character.lastname}
          </cite>
        </div>
      ))}
    </div>
  )
}
